import { ApiFactory } from "@/core/services/api-factory.service";

export class Api {
  /**
   * @return {AxiosInstance}
   */
  static new() {
    return ApiFactory.getDefaultApi(process.env.VUE_APP_API);
  }

  /**
   * To create requests that will skip the _defaultRequestHandler (cf. api-factory.service.js)
   * Only used by the getAnonymousUser request (in identification.service.js) to prevent infinite loop
   *
   * @return {AxiosInstance}
   */
  static newAuthentication() {
    return ApiFactory.getNewAuthentificationApi(process.env.VUE_APP_API);
  }
}

export const addTokenToHeaders = (cirxToken) => {
  ApiFactory.cirxToken = cirxToken;
};

export const addCirxModuleToHeaders = (cirxModule) => {
  ApiFactory.cirxModule = cirxModule;
};

export const removeCirxModuleFromHeaders = () => {
  ApiFactory.cirxModule = "";
};

export const addTokenToAuthorization = (bearerToken) => {
  ApiFactory.bearerToken = bearerToken;
};

/**
 * Returns the query parameters string. If baseUrl is given, it returns the entire url
 *
 * @param {(string|null)[]} params - array of values that can be strings or null
 * @param {string} baseUrl - optional parameter to return the entire url
 *
 * @return {string}
 */
export const makeUrlParams = (params, baseUrl = "") => {
  let paramsStr = params.filter((v) => v).join("&");
  paramsStr = paramsStr.length ? `?${paramsStr}` : "";

  return baseUrl + paramsStr;
};
